import { queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';

import { reportKeys } from './report-keys';

export function inventoryReportQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: reportKeys.inventory(storeId),
    queryFn: () => reportsApi.inventory(storeId),
  });
}

export function useInventoryReport(storeId: string) {
  return useQuery(inventoryReportQueryOptions(storeId));
}
